import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash-es';
import DropdownHeader from './DropdownHeader';
import AppsList from './AppsList';
import PublishersList from './PublishersList';

const CompanyList = ({
  scrollableTarget,
  data,
  active,
}) => {
  const { apps, publishers } = data;

  return (
    <Fragment>
      { !isEmpty(publishers) && <PublishersList data={publishers} /> }
      <div className="d-flex align-items-center pl-xs header b-t">
        <DropdownHeader headerName="Applications" />
      </div>
      <AppsList data={apps} scrollableTarget={scrollableTarget} active={active} />
    </Fragment>
  );
};

CompanyList.propTypes = {
  data: PropTypes.object.isRequired,
  scrollableTarget: PropTypes.string.isRequired,
  active: PropTypes.object.isRequired,
};

export default CompanyList;
